import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../App";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";

export default function SalonLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (!email.trim() || !password) return toast.error("Email and password are required");
    setBusy(true);
    try {
      await axios.post(`${API}/salons/login`, { email: email.trim().toLowerCase(), password });
      nav("/salon/dashboard");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Invalid credentials");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-6" data-testid="salon-login">
      <div className="max-w-md w-full">
        <Link to="/salon" className="text-[11px] kt-tracking-wider uppercase text-[#6F6B66]">
          ← Hairtu Professional
        </Link>
        <div className="mt-8">
          <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-3">— Salon sign in</div>
          <h1 className="font-serif text-4xl leading-tight text-[#383633] tracking-tight mb-8">
            Welcome back.
          </h1>
          <div className="space-y-4">
            <div>
              <Label htmlFor="email" className="text-xs kt-tracking uppercase text-[#6F6B66]">Business email</Label>
              <Input id="email" data-testid="input-salon-email" value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="mt-2 border-[#ECE7DF] bg-white rounded-xl h-12 focus-visible:ring-[#383633]" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs kt-tracking uppercase text-[#6F6B66]">Password</Label>
              <Input id="password" data-testid="input-salon-password" type="password"
                value={password} onChange={(e) => setPassword(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && submit()}
                className="mt-2 border-[#ECE7DF] bg-white rounded-xl h-12 focus-visible:ring-[#383633]" />
            </div>
            <Button onClick={submit} disabled={busy} data-testid="salon-login-submit"
              className="w-full h-14 rounded-full bg-[#383633] hover:bg-[#4A4238] text-white text-xs kt-tracking uppercase">
              {busy ? "Signing in…" : "Sign in"}
            </Button>
            <div className="text-xs text-[#6F6B66] text-center pt-2">
              Don't have a salon account?{" "}
              <Link to="/salon/register" className="text-[#383633] underline underline-offset-2">
                Start your subscription
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
